<script lang="ts" setup>
useHead({ title: 'Política de Cookies' })
</script>

<template>
  <div class="mx-auto prose px-4 text-xl">
    <h1 id="pol-tica-de-cookies">Política de Cookies</h1>
    <p>
      En TICKETSMART.PE utilizamos cookies para que nuestro sitio web sea más
      rápido, por lo que queremos darte más información sobre ellas.
    </p>
    <h2 id="-qu-son-las-cookies-">¿Qué son las cookies?</h2>
    <p>
      Las cookies son pequeños archivos de texto ubicados en el directorio del
      navegador de tu computadora o dispositivo móvil. Cuando visitas un sitio
      web, se envía información al navegador que luego crea la cookie. Cada vez
      que vuelves a visitar el mismo sitio web, se accede a la información
      almacenada en la cookie.
    </p>
    <blockquote>
      <p>
        TICKETSMART.PE no utiliza cookies para almacenar información de
        identificación personal.
      </p>
    </blockquote>
    <h2 id="-para-qu-sirven-las-cookies-">¿Para qué sirven las cookies?</h2>
    <p>Las cookies se utilizan por varias razones:</p>
    <ul>
      <li>Ayudan a nuestro sitio web a recordar tus preferencias</li>
      <li>Ayudan a mejorar la funcionalidad de búsqueda de información</li>
      <li>Ayudan a supervisar el rendimiento del sitio web</li>
    </ul>
    <h2 id="cookies-esenciales">Cookies Esenciales</h2>
    <p>
      Algunas cookies son esenciales para permitir que el sitio web funcione
      correctamente. TICKETSMART.PE utiliza una cookie llamada
      &#39;_epic_alpha_session&#39; para registrar la visita de los usuarios
      cuando se conectan a nuestro sitio web.
    </p>
    <p>
      De vez en cuando, realizaremos pruebas en nuestro sitio web para ver cómo
      nuestros visitantes responden a diferentes elementos de diseño.
    </p>
    <h2 id="cookies-de-rendimiento">Cookies de rendimiento</h2>
    <p>
      Las cookies de rendimiento nos permiten realizar un seguimiento de nuestro
      análisis de sitios web. Es muy beneficioso para nosotros saber cuántos
      visitantes recibimos, de dónde están visitando, cuáles son las páginas más
      populares, qué publicaciones de blog obtienen la mayoría de las vistas y
      qué hora del día tiene el menor número de visitantes (por lo que sabemos
      el mejor tiempo para hacer el mantenimiento).
    </p>
    <h2 id="dudas">Dudas</h2>
    <p>
      Si tienes alguna inquietud sobre las cookies utilizadas por
      TICKETSMART.PE, no dudes en ponerte en contacto con nosotros para que
      podamos resolver tus dudas.
    </p>
  </div>
</template>
